import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";

const PatientsListViewSkeleton = ({ darkMode }) => {
  const rows = Array.from({ length: 13 }); // simulate 12 patients
  const headerColumns = [
    "Patient",
    "Date of Birth",
    "Age",
    "Address",
    "Tags",
    "Last Consultation",
    "Assignee",
    "Action",
  ];

  return (
    <div
      className={
        darkMode
          ? "pl-container pl-container-skeleton dark"
          : "pl-container pl-container-skeleton light"
      }
    >
      {/* Grid Skeleton */}
      <div className="patient-list-skeleton-grid">
        {/* Header row */}
        <div className="ag-header-skeleton">
          {headerColumns.map((col, idx) => (
            <div key={idx} className="ag-header-skeleton-cell">
              <Skeleton
                variant="text"
                width="40%"
                height={50}
                sx={{ bgcolor: darkMode ? "grey.700" : "" }}
              />
            </div>
          ))}
        </div>

        {/* Body rows */}
        <div className="ag-body-skeleton">
          {rows.map((_, rowIdx) => (
            <Box key={rowIdx} className="ag-row-skeleton">
              <div className="ag-cell-skeleton name">
                <div className="patient-details">
                  <Skeleton
                    variant="text"
                    width="50%"
                    height={30}
                    sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                  />
                  <Skeleton
                    variant="text"
                    width="70%"
                    height={15}
                    sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                  />
                </div>
              </div>
              <div className="ag-cell-skeleton dob">
                <Skeleton
                  variant="text"
                  width="80%"
                  height={30}
                  sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                />
              </div>
              <div className="ag-cell-skeleton age">
                <Skeleton
                  variant="text"
                  width="80%"
                  height={30}
                  sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                />
              </div>
              <div className="ag-cell-skeleton address">
                <Skeleton
                  variant="text"
                  width="80%"
                  height={30}
                  sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                />
              </div>
              <div className="ag-cell-skeleton address">
                <Skeleton
                  variant="text"
                  width="80%"
                  height={30}
                  sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                />
              </div>
              <div className="ag-cell-skeleton last">
                <Skeleton
                  variant="text"
                  width="80%"
                  height={30}
                  sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                />
              </div>
              <div className="ag-cell-skeleton assignee">
                <Skeleton
                  variant="text"
                  width="80%"
                  height={30}
                  sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                />
              </div>
              <div className="ag-cell-skeleton action">
                <Skeleton
                  variant="rectangular"
                  width={60}
                  height={30}
                  sx={{
                    bgcolor: darkMode ? "grey.800" : "",
                    borderRadius: "6px",
                  }}
                />
              </div>
            </Box>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PatientsListViewSkeleton;
